$.fn.lockForm = function() {
    var f = $(this);
    var params = f.serializeArray();
    f.find('input, textarea').attr('disabled', true);
    f.find('button[type=submit]').addClass('is-loading');

    return params;
};

$.fn.unlockForm = function() {
    var f = $(this);
    $(this).find('input, textarea').attr('disabled', false);
    f.find('button[type=submit]').removeClass('is-loading');
};


$.validator.addMethod("login", function(value, element) {
        return this.optional(element) || /^[a-z_ęółśążźćń][a-z0-9_ęółśążźćń\- ]+$/i.test(value);
    }, "Login"
);



var loginBox = {

    init: function(con){
        this.initTabs(con);
        this.initLogin(con);
        this.initRegister(con);
        this.initFb(con);
        this.initReset(con);
    },

    initFb: function(con) {
        con.find('.is-fb').click(function(){
            loginFacebook();
            return false;
        })
    },

    initTabs: function(con){
        var menu = con.find('.login-box-menu');
        var links = menu.find('a');
        links.click(function(){
            var active = links.filter('.act').removeClass('act');
            con.find(active.data('target')).hide();

            var a = $(this).addClass('act');
            con.find(a.data('target')).show();
            return false;
        });

        con.find('.forgot-link').click(function(){
            con.find('#f-login-password').val('');
            links.parent().toggle();
            //set email
            setTimeout(function(){
                links.last().click();
            })
            //
            return false;
        });
    },

    initLogin(con) {
        var form = con.find('#login-form');
        var password = form.find('#f-login-password');
        form.submit(function(){
            $.post('/login', form.lockForm(), function(data){
                window.location.reload();
            }).fail(function() {
                password.addClass('error');
                con.find('.forgot-link').show();
                con.find('#log-error').css('display', 'block');
                setTimeout(function(){
                    password.select();
                })
            }).always(function(){
                form.unlockForm();
            });
            return false;
        });
        password.on('input', function () {
            if(password.hasClass('error')){
                password.removeClass('error');
                con.find('#log-error').hide();
            }
        })
    },

    initReset(con) {
        var form = con.find('#reset-form');
        var emailImp = con.find('.input[name="email"]');
        form.submit(function(){
            $.post('/login/reset', form.lockForm(), function(data){
                form.replaceWith(data);
            }).fail(function() {
                emailImp.addClass('error');
                con.find('#reset-error').css('display', 'block');
                setTimeout(function(){
                    emailImp.select();
                })
            }).always(function(){
                form.unlockForm();
            });
            return false;
        })
        emailImp.on('input', function () {
            if(emailImp.hasClass('error')){
                emailImp.removeClass('error');
                con.find('#reset-error').hide();
            }
        })
    },

    initRegister(con){
        var form = con.find('#register-form');
        form.validate({
            //debug: true,
            rules: {
                login:    { required: true, minlength: 4, maxlength: 25, login: true, remote: "/register/validate-login"},
                password: { required: true, minlength: 5},
                email:    { required: true, email: true, remote: "/register/validate-email" },
                verify: "required"
            },
            messages: {
                login: { required: "Wpisz nazwę użytkownika", minlength: "Minimalnie 4 znaki", maxlength: "Maksymalnie 25 znaków", login: "Tylko litery, cyfry, '-', '_', oraz spacje", remote: "Ta nazwa jest już zajęta"	},
                password: { required: "Wpisz hasło", minlength: "Minimum 5 znaków" },
                email: { required: "Wpisz adres email", email: "Niepoprawny adres email", remote: "Istnieje już konto z tym adresem"	},
                verify: "Zaakceptuj regulamin portalu"
            },
            errorPlacement: function(error, element) {
                if (element.attr("name") == "verify" ) {
                    error.insertAfter(element.parent());
                } else {
                    error.insertAfter(element);
                }
            },

            submitHandler: function(){
                $.post('/register', form.lockForm(), function(data){
                    $('#login-box').html(data);
                });
            }

        });
    }
};


loginBox.init($('#login-box'));


var showLoginPopup = window.showLoginPopup =  function(dissableClose){
    // var content = $('<div class="white-popup"></div>');
    var content = $('#login-box').clone().addClass('login-popup');
    loginBox.init(content);
    var options = {
        items: {src: content, type: 'inline'}
    };
    if(dissableClose) {
        Object.assign(options, {
            closeOnContentClick: false,
            closeOnBgClick: false,
            closeBtnInside: false,
            enableEscapeKey: false
        });
    }
    setTimeout(function(){
        $.magnificPopup.open(options);
    });
}

$('#login-mobile-link').click(function(){
    $('#mobile-nav-close').click();
    showLoginPopup();
    return false;
})


var loginFacebook = function (){


    FB.getLoginStatus(function(response) {
        console.log('loginFacebook');

        if (response.status === 'connected') {
            var accessToken = response.authResponse.accessToken;
            console.log(response);
            $.post("/login/facebook",{ 'token': accessToken}, function(data){
                window.location.reload();
            });
        } else {
            FB.login(function(response){
                console.log(response);
                if (response.status === 'connected') {
                    var accessToken = response.authResponse.accessToken;
                    $.post("/login/facebook",{ 'token': accessToken}, function(data){
                        window.location.reload();
                    });
                    //alert('podlaczony');
                } else if (response.status === 'not_authorized') {
                    //alert('nie ma uprawnien');
                } else {
                    //alert('inne');
                }
            },{scope: 'email'});
        }
    }, true);


    // window.fbAsyncInit = function() {
    //     FB.init({
    //         appId      : $('meta[property="fb:app_id"]').attr('content'), // App ID
    //         status     : false, // check login status
    //         cookie     : false, // enable cookies to allow the server to access the session
    //         xfbml      : false,  // parse XFBML
    //         version    : 'v3.3'
    //         // version    : 'v2.3'
    //     });
    //
    //     FB.login(function(response){
    //         if (response.status === 'connected') {
    //             var uid = response.authResponse.userID;
    //             var accessToken = response.authResponse.accessToken;
    //
    //             $.post("/login/facebook",{ 'token': accessToken}, function(data){
    //                 window.location.reload();
    //             });
    //             //alert('podlaczony');
    //         } else if (response.status === 'not_authorized') {
    //             // alert('nie ma uprawnien');
    //         } else {
    //             //alert('inne');
    //         }
    //     },{scope: 'email'});
    //
    // };
    //
    //
    // (function(d){
    //     var js, id = 'facebook-jssdk', ref = d.getElementsByTagName('script')[0];
    //     if (d.getElementById(id)) {return;}
    //     js = d.createElement('script'); js.id = id; js.async = true;
    //     // js.src = "https://connect.facebook.net/en_US/sdk/debug.js";
    //     js.src = "https://connect.facebook.net/pl_PL/sdk.js";
    //     ref.parentNode.insertBefore(js, ref);
    // }(document));






    // (function(d, s, id){
    //     var js, fjs = d.getElementsByTagName(s)[0];
    //     if (d.getElementById(id)) {return;}
    //     js = d.createElement(s); js.id = id;
    //     js.src = "https://connect.facebook.net/pl_PL/sdk.js";
    //     fjs.parentNode.insertBefore(js, fjs);
    // }(document, 'script', 'facebook-jssdk'));

}




// WEBPACK FOOTER //
// ./Resources/assets/js/login.js